import React from 'react';
import { injectIntl } from 'react-intl';
import { Modal } from 'antd';

import { getPinLocationAreas } from 'services/cities';
import { sendSegment } from 'utils/segment';
import { COUNTRY_POINT_MAP } from 'constants/pickups';
import { MAP_MARKER_STATUS, ERROR_STATUS } from 'constants/brGoogleMap';

import BRGoogleMap from 'components/BRGoogleMap/BRGoogleMap';
import BRContentHeader from 'components/BRContentHeader/BRContentHeader';
import BRButton from 'components/BRButton/BRButton';

import './GoogleMapModal.less';

class GoogleMapModal extends React.Component {
  state = {
    userAddress: null,
    userPosition: COUNTRY_POINT_MAP,
    pickupAvailability: true,
    isLoading: false,
    locatedDistrict: false,
    markerStatus: '',
    googleMapResponse: []
  };

  componentDidMount() {
    const { isMapUsed } = this.props;
    const { SUCCESS, INITIAL } = MAP_MARKER_STATUS;
    this.handleMarkerStatusChange(isMapUsed ? SUCCESS : INITIAL);
  }

  handleConfirmLocation = async () => {
    const { LOADING, SUCCESS, FAILED, UNDETERMINED } = MAP_MARKER_STATUS;
    this.handleMarkerStatusChange(LOADING);
    const { userPosition } = this.state;
    const payload = { ...userPosition, context: 'pickup' };
    try {
      this.setState({ isLoading: true });
      const data = await getPinLocationAreas(payload);
      sendSegment('PIN_LOCATION_MAPPED_SUCCESSFULLY', {
        'Mapped to city': data[0]?.cityName ? 'Yes' : 'No',
        'Mapped to district': data[0]?.districtName ? 'Yes' : 'No',
        'City name': data[0]?.cityName,
        'District name': data[0]?.districtName
      });

      if (data.length) {
        this.setState({ googleMapResponse: data });
        if (data.length === 1) {
          this.handleMarkerStatusChange(
            data[0].pickupAvailability ? SUCCESS : FAILED
          );
        } else {
          const availableAreas = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].pickupAvailability) {
              availableAreas.push(data[i]);
            }
          }
          if (availableAreas.length) {
            this.handleMarkerStatusChange(SUCCESS);
          } else {
            this.setState({
              pickupAvailability: false,
              locatedDistrict: true
            });
            this.handleMarkerStatusChange(FAILED);
          }
        }
      } else {
        this.setState({ pickupAvailability: false });
        this.handleMarkerStatusChange(FAILED);
      }
      this.setState({ isLoading: false });
    } catch (error) {
      sendSegment('PIN_LOCATION_COULD_NOT_BE_MAPPED', {
        'Error message': error.message
      });
      this.setState({ pickupAvailability: false });
      this.handleMarkerStatusChange(
        error.status === ERROR_STATUS.UNDETERMINED_LOCATION
          ? UNDETERMINED
          : FAILED
      );
    }
    this.setState({ isLoading: false });
  };

  confirmLocationButtonClicked = async () => {
    const { close, onSuccess } = this.props;
    const { userPosition, userAddress } = this.state;
    if (this.state.googleMapResponse.length) {
      if (this.state.googleMapResponse.length === 1) {
        if (this.state.googleMapResponse[0].pickupAvailability) {
          onSuccess({
            userPosition,
            userAddress,
            response: this.state.googleMapResponse
          });
          close();
        }
      } else {
        const availableAreas = [];
        this.state.googleMapResponse.forEach((zone) => {
          if (zone.pickupAvailability) {
            availableAreas.push(zone);
          }
        });
        if (availableAreas.length) {
          onSuccess({
            userPosition,
            userAddress,
            response: this.state.googleMapResponse,
            availableAreas
          });
          close();
        }
      }
    } else {
      close();
    }
  };

  setUserPosition = (userPosition) => {
    this.setState({ userPosition });
  };

  setUserAddress = (fulluserAddress) => {
    this.setState({ userAddress: fulluserAddress });
  };

  handleNewSearchInput = () => {
    this.setState({ pickupAvailability: true, locatedDistrict: false });
  };

  handleMarkerStatusChange = (status) => {
    this.setState({ markerStatus: status });
  };

  render() {
    const { close, intl, position, isMapUsed } = this.props;
    const { pickupAvailability, isLoading, locatedDistrict, markerStatus } =
      this.state;
    const { SUCCESS } = MAP_MARKER_STATUS;

    return (
      <Modal
        {...this.props}
        footer={null}
        title={null}
        onCancel={close}
        width={null}
        wrapClassName="br-google-map-modal"
      >
        <BRContentHeader
          title={intl.formatMessage({
            id: 'br_google_map.actions.add_location'
          })}
          className="br-google-map-modal"
          titleClassName="br-google-map-modal__title display-xs"
        />
        <BRGoogleMap
          setCurrentPosition={this.setUserPosition}
          setCurrentAddress={this.setUserAddress}
          handleNewSearchInput={this.handleNewSearchInput}
          isMapUsed={isMapUsed}
          userPosition={position}
          className="br-google-map-modal_location"
          withSearch
          close={close}
          handleConfirmLocation={this.handleConfirmLocation}
          markerStatus={markerStatus}
          shouldDetectUserLocationOnMount
        />
        <div className="br-google-map-modal_location__footer">
          <BRButton
            type="basic"
            onClick={close}
            label={intl.formatMessage({
              id: 'common.cancel'
            })}
          />
          {pickupAvailability && !locatedDistrict ? (
            <BRButton
              disabled={markerStatus !== SUCCESS}
              type="primary"
              onClick={this.confirmLocationButtonClicked}
              label={intl.formatMessage({
                id: 'br_google_map.actions.confirm_location'
              })}
            />
          ) : (
            <BRButton
              type="primary"
              onClick={close}
              label={intl.formatMessage({
                id: 'br_google_map.actions.add_manually'
              })}
            />
          )}
        </div>
      </Modal>
    );
  }
}

export default injectIntl(GoogleMapModal);
